import script from "./RoamingView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RoamingView.vue?vue&type=script&lang=ts&setup=true"

import "./RoamingView.vue?vue&type=style&index=0&id=5e57bfd2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e57bfd2"]])

export default __exports__